import { t } from 'i18next';
import React from 'react';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { deleteUser } from '../../pages/CustomerUsers/CustomerUsersSlice';

const ModalDeleteCustomerUser = ({ show, setShow, userId, customerId }) => {
  const token = localStorage.getItem('token');
  const dispatch = useDispatch();

  const handleClose = () => setShow(false);

  const handleDeleteUser = () => {
    dispatch(deleteUser({ token, userId }));
    setShow(false);
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{t('delete-title')}</Modal.Title>
      </Modal.Header>
      <Form>
        <Modal.Body>
          <Row>
            <Col sm={12}>
              <Modal.Title>{t('delete-message')}</Modal.Title>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {t('close')}
          </Button>
          <Button variant="danger" onClick={handleDeleteUser}>
            {t('delete-submit')}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ModalDeleteCustomerUser;
